export const lang = process.env.REACT_APP_LANG;
export const name = process.env.REACT_APP_NAME;
export const apiURL = 'https://api.crazyfriedchicken.co.uk/cfc/api/v1';
export const authURL = 'https://api.crazyfriedchicken.co.uk/cfc/api/v1';
export const ImageURL = 'https://api.crazyfriedchicken.co.uk/cfc';
